import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from './shared/shared.module';
import {ReactiveFormsModule} from '@angular/forms';
import {AdminRequestNoticeComponent} from './views/admin-request/admin-request-notice/admin-request-notice.component';
import {PrintNoticeReportingComponent} from './components/print-notice-reporting/print-notice-reporting.component';
import {PrintNoticeRestrictionComponent} from './components/print-notice-restriction/print-notice-restriction.component';
import {PrintNoticeRefusalComponent} from './components/print-notice-refusal/print-notice-refusal.component';
import {FaIconComponent, ICON_SCROLL_INDICATOR, LG_ICON_SCROLL_INDICATOR, NgxSatorisModule} from 'ngx-satoris';
import {StandbyKioskComponent} from './views/standby-kiosk/standby-kiosk.component';
import {QRCodeModule} from 'angularx-qrcode';
import {StandbyDescKioskComponent} from './views/standby-kiosk/standby-desc-kiosk/standby-desc-kiosk.component';
import {SuccessKioskComponent} from './views/payment/success-kiosk/success-kiosk.component';
import {VisaExtendComponent} from './views/form-visa/8.visa-extend/visa-extend.component';
import {PrintApprovalLetterComponent} from './components/print-approval-letter/print-approval-letter.component';
import {PrintDecisionLetterComponent} from './components/print-decision-letter/print-decision-letter.component';
import {PrintReceiptA5Component} from './components/print-receipt-a5/print-receipt-a5.component';
import {DialogEditPassportComponent} from './components/dialogs/dialog-edit-passport/dialog-edit-passport.component';
import {MatDialogModule} from '@angular/material/dialog';
import {PrintSettingsComponent} from './views/account/print-settings/print-settings.component';
import {PrintMasterComponent} from './components/print-master/print-master.component';
import {PrintDataComponent} from './components/print-data/print-data.component';
import {PrintComponent} from './components/print/print.component';
import {PrintNoticeBorderPassComponent} from './components/print-notice-border-pass/print-notice-border-pass.component';
import {PrintSingleDocumentComponent} from './components/print-single-document/print-single-document.component';
import {ZimswitchComponent} from './components/zimswitch/zimswitch.component';
import {PrintQrListComponent} from './components/print-qr-list/print-qr-list.component';

@NgModule({
  declarations: [
    AdminRequestNoticeComponent,
    PrintNoticeReportingComponent,
    PrintNoticeRestrictionComponent,
    PrintNoticeRefusalComponent,
    StandbyKioskComponent,
    StandbyDescKioskComponent,
    SuccessKioskComponent,
    VisaExtendComponent,
    PrintApprovalLetterComponent,
    PrintDecisionLetterComponent,
    PrintReceiptA5Component,
    DialogEditPassportComponent,
    PrintSettingsComponent,
    PrintMasterComponent,
    PrintDataComponent,
    PrintComponent,
    PrintNoticeBorderPassComponent,
    PrintSingleDocumentComponent,
    ZimswitchComponent,
    PrintQrListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSatorisModule,
    QRCodeModule,
    FaIconComponent,
    MatDialogModule
  ],
  providers: [
    AdminRequestNoticeComponent,
    PrintNoticeReportingComponent,
    PrintNoticeRestrictionComponent,
    PrintNoticeRefusalComponent,
    StandbyKioskComponent,
    StandbyDescKioskComponent,
    SuccessKioskComponent,
    VisaExtendComponent,
    PrintApprovalLetterComponent,
    PrintReceiptA5Component,
    PrintSettingsComponent,
    DialogEditPassportComponent,
    PrintMasterComponent,
    PrintDataComponent,
    PrintComponent,
    PrintNoticeBorderPassComponent,
    PrintSingleDocumentComponent,
    {provide: ICON_SCROLL_INDICATOR, useValue: 'assets/images/chevron-down.svg'},
    {provide: LG_ICON_SCROLL_INDICATOR, useValue: 'assets/images/mouse-wheel.svg'}
  ],
  exports: [
    PrintNoticeReportingComponent,
    PrintNoticeRestrictionComponent,
    PrintNoticeRefusalComponent,
    PrintApprovalLetterComponent,
    PrintReceiptA5Component,
    DialogEditPassportComponent,
    PrintSettingsComponent,
    PrintMasterComponent,
    PrintDataComponent,
    PrintComponent,
    PrintNoticeBorderPassComponent,
    PrintSingleDocumentComponent
  ]
})
export class VisaModule { }
